import React from "react";
import { cn } from "../../lib/utils";

export function LoadingState({ label = "Cargando...", className }) {
  return (
    <div className={cn("valhalla-card px-5 py-10 text-center sm:p-12", className)}>
      <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-[#242E42] border-t-[#E2B05E]" />
      <p className="text-sm text-[#9CA3AF]">{label}</p>
    </div>
  );
}

export default LoadingState;
